var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDtr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#121747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.143 12.8644C10.143 13.5085 9.6255 14.031 8.9865 14.031C8.3475 14.031 7.83056 13.5085 7.83056 12.8639V5.10754C7.83056 4.46348 8.34806 3.94092 8.9865 3.94092C9.62494 3.94092 10.143 4.46348 10.143 5.10811V12.8644ZM6.2505 12.8672C6.25425 13.0731 6.20339 13.2763 6.1031 13.4561C6.00281 13.6359 5.85668 13.786 5.67956 13.891C5.50342 13.9951 5.30255 14.05 5.09794 14.05C4.89332 14.05 4.69246 13.9951 4.51631 13.891C4.33931 13.7859 4.19328 13.6358 4.0931 13.456C3.99291 13.2762 3.94214 13.073 3.94594 12.8672V11.1235C3.94214 10.9177 3.99291 10.7145 4.0931 10.5347C4.19328 10.3549 4.33931 10.2048 4.51631 10.0997C4.69246 9.99561 4.89332 9.94068 5.09794 9.94068C5.30255 9.94068 5.50342 9.99561 5.67956 10.0997C5.85657 10.2048 6.0026 10.3549 6.10278 10.5347C6.20297 10.7145 6.25374 10.9177 6.24994 11.1235L6.2505 12.8672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.0377 9.78758C14.0377 10.4316 13.5202 10.9542 12.8812 10.9542C12.2422 10.9542 11.7247 10.4311 11.7247 9.78702V6.84346C11.7247 6.19883 12.2422 5.67627 12.8812 5.67627C13.5202 5.67627 14.0377 6.19883 14.0377 6.84346V9.78758Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDtr);
export default __webpack_public_path__ + "static/media/dtr.8e679ebe0e76c8c25426e99bb494a23b.svg";
export { ForwardRef as ReactComponent };